import { FigmaExporterProcessedStylesSchema, } from "./figma-exporter-styles";
import { textBlockSchema, } from "./figma-exporter-text-content";
import { z } from "zod";
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Schema Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
const FigmaExporterDesignNodeTypeSchema = z.union([
    z.literal("FRAME"),
    z.literal("TEXT"),
    z.literal("SVG"),
    z.literal("IMAGE"),
    z.literal("COMPONENT_INSTANCE"),
    z.literal("MASK_GROUP"),
]);
// Base schema without children for extension
const baseDesignNodeObjectSchema = z.object({
    id: z.string(),
    name: z.string(),
    type: FigmaExporterDesignNodeTypeSchema,
    parentId: z.string().nullable(),
    styles: FigmaExporterProcessedStylesSchema.partial(),
});
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Individual node schemas extending the base
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
const frameNodeObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("FRAME"),
});
const textNodeObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("TEXT"),
    content: z.array(textBlockSchema),
});
const svgNodeObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("SVG"),
    svgString: z.string(),
});
const imageNodeObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("IMAGE"),
    src: z.string(),
});
const componentInstanceObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("COMPONENT_INSTANCE"),
    componentSetName: z.string(),
    componentSetDescription: z.string(),
    componentName: z.string(),
    componentDescription: z.string(),
    props: z.record(z.string(), z.union([z.string(), z.boolean()])),
});
const svgMaskDefinitionSchema = z.object({
    type: z.literal("SVG_MASK"),
    svgString: z.string(),
    width: z.number(),
    height: z.number(),
});
const rectClipMaskDefinitionSchema = z.object({
    type: z.literal("RECT_CLIP"),
    width: z.number(),
    height: z.number(),
    borderRadius: z.string().optional(),
});
const ellipseClipMaskDefinitionSchema = z.object({
    type: z.literal("ELLIPSE_CLIP"),
    width: z.number(),
    height: z.number(),
});
const FigmaExporterMaskDefinitionSchema = z.union([
    svgMaskDefinitionSchema,
    rectClipMaskDefinitionSchema,
    ellipseClipMaskDefinitionSchema,
]);
const maskGroupNodeObjectSchema = baseDesignNodeObjectSchema.extend({
    type: z.literal("MASK_GROUP"),
    maskType: z.union([z.literal("ALPHA"), z.literal("VECTOR")]),
    maskSourceId: z.string(),
    maskSourceName: z.string(),
    maskDefinition: FigmaExporterMaskDefinitionSchema,
});
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Final Schemas with children
// --- --- --- --- --- --- --- --- --- --- --- --- --- ---
const frameNodeSchema = z.lazy(() => frameNodeObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
}));
// Text nodes don't have children
const textNodeSchema = textNodeObjectSchema;
const svgNodeSchema = z.lazy(() => svgNodeObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
}));
// Image nodes don't have children
const imageNodeSchema = imageNodeObjectSchema;
const componentInstanceNodeSchema = z.lazy(() => componentInstanceObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
}));
const maskGroupNodeSchema = z.lazy(() => maskGroupNodeObjectSchema.extend({
    children: FigmaExporterAnyDesignNodeSchema.array(),
}));
export const FigmaExporterAnyDesignNodeSchema = z.union([
    frameNodeSchema,
    textNodeSchema,
    svgNodeSchema,
    imageNodeSchema,
    componentInstanceNodeSchema,
    maskGroupNodeSchema,
]);
